<script>import { api, Formrow, IconSearch, Button, IconSpinner, Dateformat } from "duo-kit";
import { fade } from "svelte/transition";
import { onMount } from "svelte";
let qs = new URLSearchParams(window.location.search);
let query = qs.get("search");
let answering = false;
let loading = false;
let results = [];
let answer = null;
let answerText = [];
let references, relatedQuestions;
let searchForm;

function byteToCharOffset(text, byteOffset) {
  return Buffer.from(text, "utf8").slice(0, byteOffset).toString("utf8").length;
}

onMount(() => {
  searchForm.querySelector("input").focus();
});

async function handleSearch(e) {
  if (e) e.preventDefault();
  answering = true;
  const url = new URL(window.location); // updating qs

  url.searchParams.set("search", query);
  history.pushState(null, '', url);

  try {
    let qs = new URLSearchParams({
      q: query
    });
    let res = await api.load({
      url: `/duocms/api/nafems/gaiolas_answer?${qs}`
    });
    answer = res.data.answer.state == "SUCCEEDED" ? res.data.answer : null; // turn answer response into an array of utf8 chars

    const segmenter = new Intl.Segmenter("en", {
      granularity: "grapheme"
    });
    answerText = Array.from(segmenter.segment(answer.answerText)).map(seg => seg.segment);
    console.log(answerText); // try and fix all citation indexes

    if (answer.citations) {
      answer.citations = answer.citations.map(c => {
        return { ...c,
          startIndex: byteToCharOffset(answer.answerText, c.startIndex || 0),
          endIndex: byteToCharOffset(answer.answerText, c.endIndex)
        };
      });
    }

    references = res.data.answer.references;
    relatedQuestions = res.data.answer.relatedQuestions;
  } catch (err) {}

  answering = false;
}

if (query) {
  handleSearch();
}</script>


<form class="search" on:submit={handleSearch} bind:this={searchForm}>
  <Formrow name="q" type="search" disabled={loading} bind:value={query} placeholder="Type your questions here, and press enter to submit">
    <div slot="suffix">
      <Button type="submit" disabled={loading} size="lg" mode="primary">
        {#if loading}<IconSpinner />{:else}<IconSearch />{/if}</Button>
    </div>
  </Formrow>
</form>



<div class="layout">
  {#if answering || answer}
    <div class="answer">
      {#if answering}
        <p><IconSpinner /> Thinking... </p>
      {:else if !answering && answer.answerText}
        <div transition:fade>
          {#if answer.citations}
            <p>
              {#each answer.citations as citation,cix}
                  {@html answerText.slice(citation.startIndex || 0, citation.endIndex).join("").replace(/\n/g,"<br><br>")}
                  {#each citation.sources as source}
                    <sup class="cite">
                      <a href={references[source.referenceId].chunkInfo.documentMetadata.structData.ext_uri} target="_blank" title={references[source.referenceId].chunkInfo.documentMetadata.title}>
                        {Number(source.referenceId)+1}
                      </a> 
                    </sup>
                  {/each}
                  {#if answerText.slice(Number(citation.endIndex)-1,Number(citation.endIndex)+1).join("").includes("\n")}
                    <br><br>
                  {/if}
              {/each}
            </p>
          {:else}
            {#each answer.answerText.split(/\n/) as line}
              <p>{line}</p>
            {/each}
          {/if}

        </div>
        <p transition:fade class="info">
          <span class="fa fa-info-circle"></span> AI responses may include mistakes. <a href="/about-us/legal/privacy/" target="_blank">Privacy Policy</a>
        </p>
      {/if}
    </div>
    <div class="duorow row">
      {#if references && references.length}
        <div class="col-xs-12 col-sm-6">
          <h5>Sources</h5>
          <ol>
            {#each references as reference}
              <li>
                <p>
                  <a href={reference.chunkInfo.documentMetadata.structData.ext_uri} target="_blank">{reference.chunkInfo.documentMetadata.title}</a> (page {reference.chunkInfo.documentMetadata.pageIdentifier})
                  <br>
                  <details><summary>Source Details</summary>
                    <ul>
                      <li>Date: <Dateformat date={reference.chunkInfo.documentMetadata.structData.Date} /></li>
                      <li>Author: {reference.chunkInfo.documentMetadata.structData.Author}</li>
                      <li>Region: {reference.chunkInfo.documentMetadata.structData.Region}</li>
                      <li>Access: {reference.chunkInfo.documentMetadata.structData.Access}</li>
                      <li>Type: {reference.chunkInfo.documentMetadata.structData.Type}</li>
                    </ul>
                    <br>
                    <strong>Source</strong><br>{reference.chunkInfo.content}
                  </details>
                </p>
              </li>
            {/each}
          </ol>
        </div>
      {/if}
      
      {#if relatedQuestions && relatedQuestions.length}
        <div class="col-xs-12 col-sm-6">
          <h5>Related Questions</h5>
          <ol>
            {#each relatedQuestions as related}
              <li><a href="?search={related}">{related}</a></li>
            {/each}
          </ol>
        </div>
      {/if}
    </div>
  {/if}

  <div class="results">
    {#if results.length}
      <ol>
      {#each results as result}
        <li>
          <a href={result.document.derivedStructData.link}><h3>{@html result.document.derivedStructData.htmlTitle}</h3></a>
          {#each result.document.derivedStructData.extractive_answers.map(e => e.content) as content}
            <p class="shottext">{@html content}</p>
          {/each}
        </li>
      {/each}
      </ol>
    {/if}
  </div>
</div>

<style>
  form{
    --s-primary:#c00;
  }

  .cite a{
    background:#cc000022;
    color:#c00;
    display:inline-block;
    padding:2px 4px;
    line-height:14px;
    margin:1px;
    font-size:12px;
  }

  .layout summary{
    display:list-item;
    cursor: pointer;
  }
  .layout summary:hover{
    color:#d00;
  }
  .layout{
    display:flex;
    flex-direction: column;
    gap:30px;
  }
  .answer{
    padding:40px;
    border:1px solid #ddd;
    border-radius:5px;
    margin:5px;
    position: relative;
  }
  .answer p{
    font-size:18px;
  }
  .answer p.info{
    font-size:14px;
    position: absolute;
    background:white;
    padding:10px 20px;
    bottom:-30px;
    right:10px;
  }

  .shottext {
   overflow: hidden;
   display: -webkit-box;
   -webkit-line-clamp: 3; /* number of lines to show */
           line-clamp: 3; 
   -webkit-box-orient: vertical;
  }

  a h3 {
    color:#c00;
  }

  .search{
    --s-primary:#283748;
    max-width:600px;
    margin:0 auto 30px auto;

  }
  .search :global(.form-row input.form-input){
    font-size:21px;
    padding: 10px 20px;
    height:52px;
  }

  .search :global(.form-row input.form-input:focus-visible){
    outline:0; 
  }
  .search :global(.form-row){
    box-shadow: 0 0 0 4px #fff,0 0 0 0px #1c9585;
    border-radius: 4px;
    transition: box-shadow 0.5s;
  }
  .search :global(.form-row:has(input.form-input:focus-visible)){
    box-shadow: 0 0 0 4px #fff,0 0 0 7px #1c9585;
    border-radius: 4px;
  }

</style>